import { useEffect } from 'react'
import { useUser } from '@fs/zion-user'
import useEP from '../../shared/hooks/useEP'
import { useTreeDispatch, useTreeState } from '../state/TreeStore'
import { getMiniTree } from '../services/services'
import locatePersonByAtn from '../helpers/tree_Helper'

export const useMiniTree = () => {
  const [epState, epDispatch] = useEP(getMiniTree)
  const { load } = epState
  const { personId } = useUser()
  const treeDispatch = useTreeDispatch()
  const treeState = useTreeState()

  useEffect(() => {
    if (personId) {
      epDispatch({ type: 'load' })
    }
  }, [epDispatch, personId])

  useEffect(() => {
    const miniTree = { ...treeState.userTree }
    if (load && !miniTree[1].personId) {
      getMiniTree().then((res) => {
        if (res) {
          Object.entries(miniTree).forEach(([key], index) => {
            miniTree[key] = locatePersonByAtn(res.data, index + 1) || miniTree[index + 1]
          })

          epDispatch({ type: 'complete', res })
          treeDispatch({
            type: 'TREE_INIT_STATE',
            payload: {
              data: miniTree,
            },
          })
        }
      })
    }
  }, [treeDispatch, epDispatch, treeState.userTree, load])

  return treeState
}

export default { useMiniTree }
